module.exports = __webpack_public_path__ + "assets/favicons/profile-picture.png";